import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

import { getLink } from './consts';

export const getDeepLink = (entity, project, type = '') => {
  const projectId = project.projectId || project.id;
  return `${getAccOrigin()}/cost/${getLink(
    type,
    projectId,
    entity,
  )}?preview=${entity.id}`;
};
